import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import Icon from '../Icon';
import { useTheme } from '../../contextProviders';

const baseClasses =
  'first:border-0 border-t border-secondary-light cursor-pointer select-none outline-none';

const StudyItem = ({
  date,
  description,
  numInstances,
  modalities,
  trackedSeries,
  isActive,
  onClick,
}) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation('StudyItem');
  return (
    <div
      className={classnames(
        isActive && !isDarkMode ? '!hover:bg-customLightColor-level3 !bg-[#75b1b1]' : '!hover:bg-secondary-main !bg-secondary-dark',
        baseClasses
      )}
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex="0"
    >
      <div className="flex flex-1 flex-col px-4 pb-2">
        <div className="flex flex-row items-center justify-between pt-2 pb-2">
          <div className={`text-base`} style={{ color: isDarkMode ? "white" : "black" }}>{date}</div>
          <div className={`flex flex-row items-center text-base`} style={{ color: isDarkMode ? "#90cdf4" : "black" }}>
            <Icon
              name="group-layers"
              className="mx-2 w-4"
              style={{ color: isDarkMode ? "#90cdf4" : "black" }}
            />
            {numInstances}
          </div>
        </div>
        <div className="flex flex-row items-center py-1">
          <div className={`text-l flex items-center pr-5 `} style={{ color: isDarkMode ? "#90cdf4" : "black" }}>{modalities}</div>
          <div className={`flex items-center break-words text-base`} style={{ color: isDarkMode ? "#90cdf4" : "black" }}>{description}</div>
        </div>
      </div>
      {!!trackedSeries && (
        <div className="flex-2 flex">
          <div
            className={classnames(
              'bg-[#75b1b1] mt-2 flex flex-row py-1 pl-2 pr-4 text-base ',
              isActive
                ? 'border-secondary-light flex-1 justify-center border-t'
                : 'mx-4 mb-4 rounded-sm'
            )}
            style={{
              color: isDarkMode ? "white" : "black",
              backgroundColor: isDarkMode ? "black" : "#75b1b1"
            }}
          >
            <Icon
              name="tracked"
              className="mr-2 w-4"
              style={{ color: isDarkMode ? "#90cdf4" : "black" }}
            />
            {t('Tracked series', { trackedSeries: trackedSeries })}
          </div>
        </div>
      )}
    </div>
  );
};

StudyItem.propTypes = {
  date: PropTypes.string.isRequired,
  description: PropTypes.string,
  modalities: PropTypes.string.isRequired,
  numInstances: PropTypes.number.isRequired,
  trackedSeries: PropTypes.number,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default StudyItem;
